<template>
  <CBox
    display="flex"
    flexDirection="column"
  >
    <CFlex mb="24px">
      <OmtTypography
        as="h1-bold"
        color="var(--colors-light-primary-navy-blue)"
      >
        Busca de rede credenciada
      </OmtTypography>
    </CFlex>

    <CBox mb="24px">
      <OmtTypography
        as="h2-bold"
        mb="6"
        color="#4A5E77"
        >Categoria do plano:</OmtTypography
      >
      <CFlex :flexDirection="['column', 'row']">
        <OmtRadio
          v-for="cat in categoriasPlanosAnonimo"
          :key="cat.value"
          :value="cat.value"
          :isChecked="categoria === cat.value"
          name="categoria"
          mr="4"
          :mb="['4', '0']"
          reverse
          navyBlue
          @click="categoria = cat.value"
        >
          <OmtTypography
            :as="categoria === cat.value ? 'h2-bold' : 'h2-regular'"
            :color="categoria === cat.value ? 'var(--colors-light-primary-navy-blue)' : '#4A5E77'"
          >
            {{ cat.label }}
          </OmtTypography>
        </OmtRadio>
      </CFlex>
    </CBox>

    <CBox mb="32px">
      <OmtTypography
        as="h2-bold"
        mb="4"
        color="#4A5E77"
        >Nome do plano:</OmtTypography
      >
      <OmtSelect
        :options="planosOptions"
        placeholder="Selecione o plano"
        width="100%"
        :initialValue="plano"
        :disabled="loading"
        keyProp="key"
        @change="e => setListOption(e)"
      />
    </CBox>

    <CBox
      display="flex"
      justifyContent="center"
      :mt="['24px', '100px']"
    >
      <OmtButton
        variant="solid"
        :w="['100%', '206px !important']"
        height="40px"
        borderRadius="0px"
        :disabled="disabled"
        @click.prevent.stop="continuar"
      >
        <OmtTypography
          as="h2-bold"
          :color="disabled ? 'var(--colors-light-secondary-text)' : 'white'"
        >
          Continuar
        </OmtTypography>
      </OmtButton>
    </CBox>
  </CBox>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "PlanCategory",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState("openNetworkSearch", ["planosAnonimo", "categoriasPlanosAnonimo", "tipoAtendimentoAnonimo"]),
    ...mapGetters("openNetworkSearch", ["getSelectedPlanCategory", "getSelectedPlanName"]),
    planosOptions() {
      return this.categoriasPlanosAnonimo?.find(cat => cat.value === this.categoria)?.planos || [];
    },
    categoria: {
      get() {
        return this.getSelectedPlanCategory;
      },
      set(value) {
        this.setPlanCategory(value);
      }
    },
    plano: {
      get() {
        return this.getSelectedPlanName;
      },
      set(value) {
        this.setPlanName(value);
      }
    },
    disabled() {
      return !this.categoria || !this.plano;
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["setPlanCategory", "setPlanName", "fetchPlanosCategoriasAnonimo"]),
    ...mapMutations("openNetworkSearch", ["SET_REDE", "SET_TIPO_ATENDIMENTO_ANONIMO"]),
    async loadPlanos() {
      this.$root.$emit("show-loading");
      this.loading = true;
      try {
        await this.fetchPlanosCategoriasAnonimo();
      } catch (error) {
        console.error("Erro ao carregar planos:", error);
      } finally {
        this.loading = false;
        this.$root.$emit("hide-loading");
      }
    },
    setListOption(e) {
      this.SET_REDE(e);
      this.plano = e;
      this.resetTipoAtendimento();
    },
    continuar() {
      this.$router.push({ name: "network.search" });
    },
    resetTipoAtendimento() {
      if (this.tipoAtendimentoAnonimo?.length > 0) {
        this.SET_TIPO_ATENDIMENTO_ANONIMO(null);
      }
    }
  },
  watch: {
    categoria() {
      this.setPlanName("");
      this.resetTipoAtendimento();
    }
  },
  async mounted() {
    this.loadPlanos();
  }
};
</script>
